import { z } from 'zod';
import { FormTrigger } from './db/enums';
import { customFieldSchema } from './custom-field.types';

export const formCustomFieldSchema = customFieldSchema.extend({
    required: z.boolean().optional()
});

export type FormCustomField = z.infer<typeof formCustomFieldSchema>;

export const formAssociationSchema = z
    .object({
        projectUuid: z.string().uuid(),
        folderUuid: z.string().uuid()
    })
    .partial();

export type FormAssociation = z.infer<typeof formAssociationSchema>;

export const formSchema = z.object({
    identifier: z.string(),
    title: z.string(),
    trigger: z.nativeEnum(FormTrigger),
    association: formAssociationSchema.optional()
});

export type Form = z.infer<typeof formSchema>;

export const formWithFieldsSchema = formSchema.extend({
    fields: z.array(formCustomFieldSchema)
});

export type FormWithFields = z.infer<typeof formWithFieldsSchema>;
